import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.fleets || initialState;

const makeSelectFleetsList = () =>
  createSelector(select, substate => substate.fleetsList);

const makeSelectFleet = () =>
  createSelector(select, substate => substate.fleet);

const makeSelectCentersList = () =>
  createSelector(select, substate => substate.centersList);

const makeSelectPreferredSources = () =>
  createSelector(select, substate => substate.preferredSources);

const makeSelectFleetShifts = () =>
  createSelector(select, substate => substate.fleetShifts);

const makeSelectFleetShiftsLoading = () =>
  createSelector(select, substate => substate.fleetShiftsLoading);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectPreferredSourcesLoading = () =>
  createSelector(select, substate => substate.preferredSourcesLoading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectFleetsList,
  makeSelectCentersList,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectPreferredSources,
  makeSelectPreferredSourcesLoading,
  makeSelectFleetShifts,
  makeSelectFleetShiftsLoading,
  makeSelectError,
  makeSelectFleet,
};
